module.exports = __webpack_public_path__ + "static/img/mail_icon_1.cd641080.svg";